import { render, staticRenderFns } from "./GerenciamentoRiscos.vue?vue&type=template&id=16b4c46c&scoped=true&"
import script from "./GerenciamentoRiscos.vue?vue&type=script&lang=js&"
export * from "./GerenciamentoRiscos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b4c46c",
  null
  
)

export default component.exports